import React from 'react'
import GLoading from 'tennders-market/common/components/element/GLoading'
import stylesInput from '@/styles/Input.module.scss'

const Suggestions = ({ style, suggestions, handleSuggestionSelect, onOut, suggestionsLoading = false }) => (
  <ul style={style} onMouseLeave={onOut} className={stylesInput['autocomplete-ul']}>
    {suggestions?.map((item) => (
      <li
        key={item?.locationId || item?.id || item?.value}
        onClick={() => handleSuggestionSelect(item)}
        className="cursor-pointer"
      >
        <span>{item.label}</span>
      </li>
    ))}
    {suggestionsLoading && <GLoading customStyle={{ position: 'absolute', left: 0, top: 0, height: '100%' }} />}
  </ul>
)

export default React.memo(Suggestions)
